import { Injectable, ViewContainerRef, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { TooltipDialogComponent } from "./tooltip-dialog.component";
import { TooltipDialogOptions } from "./tooltip-dialog.model";

@Injectable()
export class TooltipDialogService {
  private dialog = inject(MatDialog);

  public open(viewContainerRef: ViewContainerRef, options: TooltipDialogOptions) {
    const config = new MatDialogConfig();
    config.data = {
      options
    };
    config.panelClass = ["ddd-dialog", "wide"];
    config.backdropClass = "ddd-dialog-backdrop"; // Do not remove
    config.disableClose = false;
    config.viewContainerRef = viewContainerRef;
    const dialogRef = this.dialog.open(TooltipDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
